import React, { ReactElement } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import WelcomeTour from 'components/WelcomeTour/WelcomeTour';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';


const WelcomeContainer = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element! as ReactElement;
};

const WelcomeRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/welcome',
    element: <WelcomeContainer />,
    children: [
      { index: true, element: <WelcomeTour /> },
    ],
  },
  name: 'Welcome',
  isHidden: true,
  containerCss: 'p-5 mb-5 border-bottom container-fluid',
  iconClassName: 'bi whizzandra',
};

export default WelcomeRouteProperties;
